import { useLayoutEffect } from 'react'

/** @param {boolean} open @param {string | undefined} scrollToItemId @param {import('react').RefObject<HTMLElement | null>} listRef @param {unknown} items */
export function useFloatingMenuScrollToItem(open, scrollToItemId, listRef, items) {
  useLayoutEffect(() => {
    if (!open || !scrollToItemId) return undefined
    let cancelled = false
    const scrollSelectedToCenter = () => {
      if (cancelled) return
      const list = listRef.current
      if (!list) return
      const selectedEl = list.querySelector(`[data-menu-item-id="${CSS.escape(scrollToItemId)}"]`)
      selectedEl?.scrollIntoView({ block: 'center', inline: 'nearest' })
    }
    const raf = requestAnimationFrame(() => {
      scrollSelectedToCenter()
      requestAnimationFrame(scrollSelectedToCenter)
    })
    return () => {
      cancelled = true
      cancelAnimationFrame(raf)
    }
  }, [open, scrollToItemId, items, listRef])
}
